import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { fetchEvidence } from '../api';

export default function EvidenceModal({ detectionId, onClose }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [image, setImage] = useState('');
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    let active = true;

    async function loadEvidence() {
      setLoading(true);
      setError('');
      try {
        const response = await fetchEvidence(detectionId);
        if (!active) return;
        const b64 = response.data?.image;
        if (!b64) {
          setError('Evidence not found for this detection.');
          return;
        }
        setImage(`data:image/jpeg;base64,${b64}`);
        setMeta({
          product_id: response.data?.product_id,
          batch_id: response.data?.batch_id,
          product_name: response.data?.product_name,
          line_id: response.data?.line_id,
          shift: response.data?.shift,
          mfg_date: response.data?.mfg_date,
          expiry_date: response.data?.expiry_date,
          unit_number: response.data?.unit_number
        });
      } catch (err) {
        setError('Unable to load evidence.');
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadEvidence();
    return () => {
      active = false;
    };
  }, [detectionId]);

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div className="modal-card" onClick={(e) => e.stopPropagation()} role="dialog">
        <div className="modal-card__head">
          <h3>Evidence Snapshot #{detectionId}</h3>
          <button type="button" className="icon-btn" onClick={onClose}>
            <X size={14} />
          </button>
        </div>
        {loading && <p>Loading evidence...</p>}
        {error && <p className="error-text">{error}</p>}
        {!loading && !error && (
          <>
            <img src={image} alt="Detection evidence" className="evidence-img" />
            {meta && (
              <div className="evidence-meta">
                <p><strong>Product ID:</strong> {meta.product_id || '-'}</p>
                <p><strong>Batch ID:</strong> {meta.batch_id || '-'}</p>
                <p><strong>Product:</strong> {meta.product_name || '-'}</p>
                <p><strong>Line:</strong> {meta.line_id || '-'}</p>
                <p><strong>Shift:</strong> {meta.shift || '-'}</p>
                <p><strong>MFG:</strong> {meta.mfg_date || '-'}</p>
                <p><strong>EXP:</strong> {meta.expiry_date || '-'}</p>
                <p><strong>Unit:</strong> {meta.unit_number || '-'}</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
